import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaUsers,
  FaUserFriends,
  FaTachometerAlt,
  FaSignOutAlt,
  FaMoneyBillAlt,
  FaTrophy,
  FaHistory,
} from "react-icons/fa";

import useStore from "../store";
import api from "../services/api";

import Logo from "../assets/logo.png";

const Sidebar = () => {
  const { user, setUser } = useStore();
  if (!user) return <></>;

  const handleLogout = () => {
    api.setToken(null);
    setUser(null);
  };

  return (
    <div className="h-screen w-56 bg-black text-white flex flex-col sticky top-0 print:hidden">
      {/* Logo */}
      <div className="p-6">
        <div>
          <img src={Logo} className="h-20 w-full object-contain" />
        </div>
      </div>

      {/* Navigation Links */}
      <nav className="flex flex-col gap-2 px-3">
        <NavLink
          to="/"
          className={({ isActive }) =>
            `text-sm flex items-center gap-3 px-4 py-3 rounded-lg text-white ${
              isActive ? "bg-neutral-900 " : "hover:bg-neutral-900 "
            }`
          }
        >
          <FaTachometerAlt className="text-lg" />
          <span>Dashboard</span>
        </NavLink>

        <NavLink
          to="/customer"
          className={({ isActive }) =>
            `text-sm flex items-center gap-3 px-4 py-3 rounded-lg text-white ${
              isActive ? "bg-neutral-900 " : "hover:bg-neutral-900 "
            }`
          }
        >
          <FaUserFriends className="text-lg" />
          <span>Customers</span>
        </NavLink>
        {user.role === "admin" && (
          <NavLink
            to="/revenue"
            className={({ isActive }) =>
              `text-sm flex items-center gap-3 px-4 py-3 rounded-lg text-white ${
                isActive ? "bg-neutral-900 " : "hover:bg-neutral-900 "
              }`
            }
          >
            <FaMoneyBillAlt className="text-lg" />
            <span>Revenue</span>
          </NavLink>
        )}
        {user.role === "admin" && (
          <NavLink
            to="/payment"
            className={({ isActive }) =>
              `text-sm flex items-center gap-3 px-4 py-3 rounded-lg text-white ${
                isActive ? "bg-neutral-900 " : "hover:bg-neutral-900 "
              }`
            }
          >
            <FaMoneyBillAlt className="text-lg" />
            <span>Payments</span>
          </NavLink>
        )}
        {user.role === "admin" && (
          <NavLink
            to="/user"
            className={({ isActive }) =>
              `text-sm flex items-center gap-3 px-4 py-3 rounded-lg text-white ${
                isActive ? "bg-neutral-900 " : "hover:bg-neutral-900 "
              }`
            }
          >
            <FaUsers className="text-lg" />
            <span>Users</span>
          </NavLink>
        )}
        <NavLink
          to="/incentive"
          className={({ isActive }) =>
            `text-sm flex items-center gap-3 px-4 py-3 rounded-lg text-white ${
              isActive ? "bg-neutral-900 " : "hover:bg-neutral-900 "
            }`
          }
        >
          <FaTrophy className="text-lg" />
          <span>Incentives</span>
        </NavLink>

        {user.role === "admin" && (
          <NavLink
            to="/change_log"
            className={({ isActive }) =>
              `text-sm flex items-center gap-3 px-4 py-3 rounded-lg text-white ${
                isActive ? "bg-neutral-900 " : "hover:bg-neutral-900 "
              }`
            }
          >
            <FaHistory className="text-lg" />
            <span>Change logs</span>
          </NavLink>
        )}
      </nav>

      {/* Settings */}
      <div className="p-4 pb-10 mt-auto flex justify-center">
        <FaSignOutAlt
          className="text-lg cursor-pointer"
          onClick={handleLogout}
        />
      </div>
    </div>
  );
};

export default Sidebar;
